// Central branding configuration — update here to rebrand the entire app

export const COMPANY_NAME_1 = 'Forever'
export const COMPANY_NAME_2 = '-X'
export const COMPANY_NAME_2_WORDS = [
    '-LOVED',
    '-MISSED',
    '-JOYFUL',
    '-BRAVE',
    '-KIND',
    '-FUNNY',
    '-ARTY',
    '-LIVELY',
    '-STOKED',
    '-GIVING',
    '-VALUED',
    '-NOBLE',
    '-HONEST',
    '-UPBEAT',
    '-CARING',
    '-OPEN',
    '-GENTLE',
    '-WARM',
    '-SOCIAL',
    '-LOYAL',
    '-TRUE',
    '-BOLD',
    '-STRONG',
    '-TOUGH',
    '-BRIGHT',
    '-DRIVEN',
    '-WITTY',
    '-SMART',
    '-CALM',
    '-RAD',
    '-SILLY'
  ]
export const COMPANY_URL = 'https://forever-x.com.com'
export const ASSETS_BASE_URL = 'https://assets.forever-x.com'
export const APP_BASE_URL = 'https://www.forever-x.com'
export const API_BASE_URL = 'https://api.forever-x.com'
